"use client";

import { useEffect, useRef, useState } from "react";
import { cart, useCart } from "./cart";

export default function CartBadge() {
  const lines = useCart();
  const count = lines.reduce((n, l) => n + l.qty, 0);
  const [bump, setBump] = useState(false);
  const prev = useRef(count);

  useEffect(() => {
    if (count > prev.current) setBump(true);
    prev.current = count;
  }, [count]);

  return (
    <button type="button" className={`cart label${bump ? " bump" : ""}`} onClick={() => cart.open()} onAnimationEnd={() => setBump(false)}>
      Корзина · {count}
    </button>
  );
}
